module.exports = __webpack_public_path__ + "static/img/Image_Developer@2x.ca6600d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Image_Developer@2x.png
// module id = 7abA
// module chunks = 0